import { useState } from "react"
import format from "../utils/format"

const useAppState = () => {
  let todayDate = new Date()
  let nextYearDate = new Date()
  nextYearDate.setFullYear(nextYearDate.getFullYear() + 1)
  nextYearDate.setDate(nextYearDate.getDate() - 1)
	const [insured, setInsured] = useState({
		name: "",
		id: "",
		dateOfBirth: "",
		gender: "",
		height: "",
		weight: "",
		email: "",
		mobile: "",
		nationality: "MY",
		occupation: "",
		address1: "",
		address2: "",
		address3: "",
		postcode: "",
		addState: "",
		declare1: "",
		declare2: "",
    declare3: "",
    pdpaAgree: "",
    tncAgree: "",
    selectedPlan: "",
    pocFrom: `${todayDate.getDate()}/${todayDate.getMonth() + 1}/${todayDate.getFullYear()}`,
    pocTo: `${nextYearDate.getDate()}/${nextYearDate.getMonth() + 1}/${nextYearDate.getFullYear()}`,
    policyStart: todayDate.getTime(),
    policyEnd: nextYearDate.getTime()
  });
  
  const [plans, setPlans] = useState([
    {
      code: "Lite",
      commissionAmount: 0,
      commissionPercentage: 0,
      desc: "Lite",
      grossPremium: 72.14,
      grossPremiumAfterRebate: 61.32,
      limitPerItem: 500,
      policyEndDate: "24/03/2022",
      policyStartDate: "25/03/2021",
      rebateAmt: 10.82,
      rebatePrc: 15,
      serviceTax: 3.68,
      stampDuty: 10,
      sumInsured: 10000,
      total: 75
    },
    {
      code: "Basic",
      commissionAmount: 0,
      commissionPercentage: 0,
      desc: "Basic",
      grossPremium: 213.09,
      grossPremiumAfterRebate: 181.13,
      limitPerItem: 1250,
      policyEndDate: "24/03/2022",
      policyStartDate: "25/03/2021",
      rebateAmt: 31.96,
      rebatePrc: 15,
      serviceTax: 10.87,
      stampDuty: 10,
      sumInsured: 30000,
      total: 202
    },
    {
      code: "Prime",
      commissionAmount: 0,
      commissionPercentage: 0,
      desc: "Prime",
      grossPremium: 367.38,
      grossPremiumAfterRebate: 312.27,
      limitPerItem: 4000,
      policyEndDate: "24/03/2022",
      policyStartDate: "25/03/2021",
      rebateAmt: 55.11,
      rebatePrc: 15,
      serviceTax: 18.74,
      stampDuty: 10,
      sumInsured: 50000,
      total: 341.01
    }
  ])
  
  const reduceInsured = state => {
    // const nationality = state.nationality || insured.nationality
    // let id = state.id || insured.id
    // let nric = ''
    // if (state.dateOfBirth && nationality === 'MY') {
    //   const dob = format.date(state.dateOfBirth)
    //   nric = `${dob.substr(-2)}${dob.substr(3, 2)}${dob.substr(0, 2)}` + '-'
    // }

    setInsured({
      ...insured,
      ...state,
      // id: nric ? nric : id
    })
  }

  const [language, setLanguage] = useState('en')

	return {
		insured,
    setInsured: reduceInsured,
    plans,
    setPlans,
    language,
    setLanguage
	}	
}

export default useAppState